import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { ErrorImgWrapper, ErrorTextWrapper } from "./ErrorComponent.styles.js";
import ErrorImg from "./ErrorImg.js";
const ErrorComponent = ()=>/*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsx(ErrorImgWrapper, {
                "data-testid": "error-img-wrapper",
                children: /*#__PURE__*/ jsx(ErrorImg, {})
            }),
            /*#__PURE__*/ jsxs(ErrorTextWrapper, {
                bg: "warning.light",
                mx: 3,
                borderRadius: 12,
                py: 2,
                px: 12,
                "data-testid": "error-text-wrapper",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        children: "Lost in the Clouds. "
                    }),
                    " We're sorry, something seems to have gone wrong. Please try again in a little bit."
                ]
            })
        ]
    });
const ErrorComponent_ErrorComponent = ErrorComponent;
export { ErrorComponent_ErrorComponent as default };
